"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M13.83 17.97h-1.755l-.06 9.84a17.606 17.606 0 0 0 1.77.615zm2.76-.615V29.28c.225.015.75-.2.975-.2.27 0 .525-.015.795-.03v-11.7zm8.91 7.965a12.945 12.945 0 0 0 1.77-1.74v-7.95H25.5zM9.135 18.57l3.615-4.17 3.12 1.7s3.255-1.875 3.3-1.95c.03-.09 4.17-3.375 4.17-3.375l3.54 2.955 1.815-1.3-.315-1.2-1.38.37-3.645-3.08-7.485 5.52-3.09-1.83-4.125 4.8-2.58.18v1.665zm.135 1.785H7.5v2.385a12.843 12.843 0 0 0 1.755 1.62zm13.56-6h-1.755L21 28.455a14.667 14.667 0 0 0 1.77-.645z" }),
  React.createElement("path", { d: "M18 .75A17.26 17.26 0 0 0 .825 18.105a17.176 17.176 0 1 0 34.35 0A17.259 17.259 0 0 0 18 .75zm0 32.79a15.436 15.436 0 0 1 0-30.87 15.436 15.436 0 0 1 0 30.87z" })
);

